import { useLocation, Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

const ROUTE_LABELS: Record<string, string> = {
  dashboard: 'Accueil',
  produits: 'Articles',
  clients: 'Clients',
  fournisseurs: 'Fournisseurs',
  caisse: 'Caisse',
  ventes: 'Ventes',
  rapports: 'Rapports',
  etiquettes: 'Étiquettes',
  'facturation-bl': 'Facturation des BL',
  'factures-clients': 'Factures clients',
  'sessions-caisse': 'Sessions de caisse',
  'pieces-commerciales': 'Pièces commerciales',
  'lignes-vente': 'Lignes de vente',
  inventaire: 'État des stocks',
  mouvements: 'Mouvements de stock',
  inventaires: 'Inventaires',
  'mode-stock': 'Mode Stock',
  appareils: 'Appareils',
  fidelite: 'Types fidélité',
  'bons-reduction': 'Bons de réduction',
  'mouvements-fidelite': 'Mouvements fidélité',
  'cartes-cadeaux': 'Cartes cadeaux',
  'sms-marketing': 'Magic SMS',
  'magic-sms': 'Magic SMS',
  promotions: 'Promotions',
  'operations-commerciales': 'Opérations commerciales',
  'personnalisation-docs': 'Personnalisation docs',
  coffre: 'Coffre',
  comptabilite: 'Comptabilité',
  'transfert-comptable': 'Transfert comptable',
  lekompte: 'Lekompte',
  'transactions-cb-externes': 'Transactions CB externes',
  utilisateurs: 'Utilisateurs',
  'profils-acces': "Profils d'accès",
  'commandes-web': 'Commandes web',
  'parametres-web': 'Paramètres web',
  tutoriels: 'Formation',
  'clotures-z': 'Clôtures Z',
  'journal-fiscal': 'Journal fiscal',
  'mon-compte': 'Mon compte',
  'admin-portal': 'Portail Revendeur',
  // Config sub-pages
  config: 'Configuration',
  familles: 'Familles',
  'sous-familles': 'Sous-familles',
  marques: 'Marques',
  'classifications-1': 'Classifications N1',
  'classifications-2': 'Classifications N2',
  'classifications-3': 'Classifications N3',
  caracteristiques: 'Caractéristiques',
  variantes: 'Variantes',
  'familles-clients': 'Familles clients',
  'familles-fournisseurs': 'Familles fournisseurs',
  'familles-tarifaires': 'Familles tarifaires',
  provenances: 'Provenances',
  commentaires: 'Commentaires',
  libelles: 'Libellés',
  'types-mouvement': 'Types de mouvement',
  'modes-reglement': 'Modes de règlement',
  'delais-paiement': 'Délais de paiement',
  'fonds-caisse': 'Fonds de caisse',
  'profils-comptables': 'Profils comptables',
  'profils-tva': 'Profils TVA',
  taxes: 'Taxes',
  'comptes-bancaires': 'Comptes bancaires',
  devises: 'Devises',
  'pistes-audit': "Pistes d'audit",
  'periodes-jour': 'Périodes jour',
  'periodes-mois': 'Périodes mois',
  'periodes-annee': 'Périodes année',
  'periodes-comptable': 'Périodes comptable',
  certificat: 'Certificat',
  'profils-fidelite': 'Profils fidélité',
  identites: 'Identités',
  'codes-postaux': 'Codes postaux',
  pays: 'Pays',
  'zones-livraison': 'Zones de livraison',
  'postes-travail': 'Postes de travail',
  monnayeur: 'Monnayeur',
  import: 'Import de données',
  'parametres-dossier': 'Paramètres du dossier',
};

export default function AppBreadcrumb() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0 || (segments.length === 1 && segments[0] === 'dashboard')) {
    return null;
  }

  const crumbs = segments.map((seg, i) => ({
    label: ROUTE_LABELS[seg] || seg.charAt(0).toUpperCase() + seg.slice(1).replace(/-/g, ' '),
    path: '/' + segments.slice(0, i + 1).join('/'),
    isLast: i === segments.length - 1,
  }));

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/dashboard" className="flex items-center gap-1">
              <Home className="h-3.5 w-3.5" />
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {crumbs.map((crumb) => (
          <span key={crumb.path} className="contents">
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              {crumb.isLast ? (
                <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link to={crumb.path}>{crumb.label}</Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </span>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
